import {
  FaUniversity,
  FaGlobe,
  FaRegCheckCircle,
  FaBriefcase,
} from "react-icons/fa";

export const ReactCountUp = [
  {
    title: "Years of Experience",
    count: 5,
    icon: <FaBriefcase size={20} />,
    color: "text-blue-500", // Add color for this item
  },
  {
    title: "Universities",
    count: 400,
    icon: <FaUniversity size={20} />,
    color: "text-green-500", // Add color for this item
  },
  {
    title: "Countries",
    count: 40,
    icon: <FaGlobe size={20} />,
    color: "text-red-500", // Add color for this item
  },
  {
    title: "Visa Approved",
    count: 1000,
    icon: <FaRegCheckCircle size={20} />,
    color: "text-yellow-500", // Add color for this item
  },
];
